export default __webpack_public_path__ + "static/maintain-ai-7df667316da7fcf509649fd3f51db9ba700d98101c5348fbee6d4ac99b7d7d14.png";